import { Button } from '@/components/ui/button';

import fs from '..';

type ButtonProps = React.ComponentPropsWithoutRef<typeof Button>;

type Props = React.ComponentPropsWithoutRef<typeof fs.Fieldset> & {
  helpText?: React.ReactNode;
  submitLabel?: React.ReactNode;
  fullContentWidth?: boolean;
  primaryButton: ButtonProps;
  secondaryButton?: ButtonProps;
};

const PlainFooterFieldset = ({
  title,
  subtitle,
  children,
  helpText,
  isLoading: isLoadingFieldset,
  primaryButton,
  secondaryButton,
  externalLink,
  fullWidth,
}: Props) => {
  return (
    <fs.Fieldset
      title={title}
      subtitle={subtitle}
      externalLink={externalLink}
      isLoading={isLoadingFieldset}
      fullWidth={fullWidth}
    >
      <div>{children}</div>
      <fs.Footer>
        {helpText && <fs.FooterStatus>{helpText}</fs.FooterStatus>}
        <fs.FooterAction>
          {secondaryButton && <Button variant="outline-neutral" size="sm" {...secondaryButton} />}
          <Button size="sm" {...primaryButton} />
        </fs.FooterAction>
      </fs.Footer>
    </fs.Fieldset>
  );
};

export default PlainFooterFieldset;
